// extracted by mini-css-extract-plugin
export var bodySections = "_5n-8";
export var gray = "_5n-7";
export var green = "_5n-4";
export var iconContainer = "_5n-9";
export var iconWidgetContainer = "_5n-1";
export var phoneIcon = "_5n-2";
export var red = "_5n-5";
export var statusDot = "_5n-3";
export var widgetContainer = "_5n-0";
export var yellow = "_5n-6";